/**
 * @generated SignedSource<<1f45035fff3cf601eb95eb855c62aa37>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useFilteredCountryListForAmazonQuery$variables = Record<PropertyKey, never>;
export type useFilteredCountryListForAmazonQuery$data = {
  readonly countries: ReadonlyArray<{
    readonly name: string | null;
    readonly twoLetterISOCode: string | null;
  }>;
};
export type useFilteredCountryListForAmazonQuery = {
  response: useFilteredCountryListForAmazonQuery$data;
  variables: useFilteredCountryListForAmazonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twoLetterISOCode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useFilteredCountryListForAmazonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Country",
        "kind": "LinkedField",
        "name": "countries",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useFilteredCountryListForAmazonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Country",
        "kind": "LinkedField",
        "name": "countries",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c5a3aafcc421d2d28bfb6f04b00500e2",
    "id": null,
    "metadata": {},
    "name": "useFilteredCountryListForAmazonQuery",
    "operationKind": "query",
    "text": "query useFilteredCountryListForAmazonQuery {\n  countries {\n    name\n    twoLetterISOCode\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "418bb97bf75c8ee8e59bca9f0dce0f09";

export default node;
